import {
  OrderProductName,
  orderProductNameFromResponse,
} from './OrderProductName';
import {
  OrderProductOption,
  orderProductOptionFromResponse,
} from './OrderProductOption';
import { OrderTotal, orderTotalFromResponse } from './OrderTotal';
import {
  ProductMedia,
  productMediaFromResponse,
} from '../Product/ProductMedia';

export interface OrderProduct {
  id: number;
  name: OrderProductName;
  options: OrderProductOption[];
  companyPrice: OrderTotal;
  quantity: number;
  lineTotal: OrderTotal;
  productID: number;
  barcode?: string;
  sku?: string;
  hepsiburadaSku?: string;
  media?: ProductMedia;
  discountedAtCheckout: boolean;
}

export const orderProductFromResponse = (responseData: any): OrderProduct => ({
  id: responseData.id,
  name: orderProductNameFromResponse(responseData.product),
  options: (responseData.options ?? []).map((o: any) =>
    orderProductOptionFromResponse(o),
  ),
  companyPrice: orderTotalFromResponse(responseData.company_price),
  quantity: responseData.qty,
  lineTotal: orderTotalFromResponse(responseData.line_total),
  productID: responseData.product_id,
  barcode: responseData.barcode,
  sku: responseData.sku,
  hepsiburadaSku: responseData.hepsiburada_sku,
  media: responseData.media
    ? productMediaFromResponse(responseData.media)
    : undefined,
  discountedAtCheckout: responseData.discounted_at_checkout,
});
